
















































































import { Component, Vue } from 'vue-property-decorator';
import {
  PaperGeneratedItem,
  PaperGeneratedItemType,
  PaperGeneratedItemsGroup,
  getAlphabet,
  getOrderPaperGeneratedItem,
} from '@/resource/paper-generated-item/paper-generated-item.model';
import { axios } from '@/utils/axios';
import MainButton from '@/main-components/common/MainButton.vue';
import { PaperGenerated } from '@/resource/paper-generated/paper-generated.model';
import ModalGenerateQuestion from '@/main-components/question-generated/ModalGenerateQuestion.vue';
import {
  GenerateQuestion,
  QuestionGenerated,
} from '@/resource/question-generated/question-generated.model';
import PaperGeneratedItemContainer from '@/main-components/question-generated/PaperGeneratedItemContainer.vue';

async function getAllPaperGeneratedItems(
  paperGeneratedId: string,
): Promise<PaperGeneratedItem[]> {
  const { data } = await axios.get(
    `paper-generated/${paperGeneratedId}/paper-generated-item`,
  );
  return data;
}

async function createPaperGenerated(params: {
  name: string;
  subjectUuid: string | null;
  form: number | null;
  chapterId: number | null;
}): Promise<PaperGenerated> {
  const { data } = await axios.post('paper-generated', params);
  return data;
}

async function createQuestionGenerated(
  newQuestion: GenerateQuestion,
): Promise<QuestionGenerated> {
  const { data } = await axios.post('question-generated', { ...newQuestion });
  return data;
}

async function updateQuestionGenerated(
  questionGeneratedId: number,
  html: string,
): Promise<QuestionGenerated> {
  const { data } = await axios.put(
    `question-generated/${questionGeneratedId}`,
    { html },
  );
  return data;
}

async function createPaperGeneratedItem(params: {
  order: number;
  type: PaperGeneratedItemType;
  paperGeneratedId: number;
  questionGeneratedId: number | null;
  text: string | null;
}): Promise<PaperGeneratedItem> {
  const { data } = await axios.post('paper-generated-item', params);
  return data;
}

async function updatePaperGeneratedItem(
  paperGeneratedItemId: number,
  questionGeneratedId: number,
): Promise<PaperGeneratedItem> {
  const { data } = await axios.put(
    `paper-generated-item/${paperGeneratedItemId}`,
    {
      questionGeneratedId,
    },
  );
  return data;
}

async function getOnePaperGenerated(
  paperGeneratedId: string,
): Promise<PaperGenerated> {
  const { data } = await axios.get(`paper-generated/${paperGeneratedId}`);
  return data;
}

@Component({
  components: {
    MainButton,
    ModalGenerateQuestion,
    PaperGeneratedItemContainer,
  },
})
export default class AdminGeneratedPaper extends Vue {
  isLoading = true;
  paperGeneratedItemsGroups: PaperGeneratedItemsGroup[] = [];
  paperGenerated: PaperGenerated | null = null;
  openModalGenerateQuestion: any = null;
  selectedpaperGeneratedItem: PaperGeneratedItem | null = null;

  get paperGeneratedId() {
    return this.$route.params.id;
  }

  async created() {
    this.paperGenerated = await getOnePaperGenerated(this.paperGeneratedId);

    // currentOrder =
    let currentOrder = 1;
    let currentParentOrder: number | null = null;
    let currentSubOrder = 1;

    (await getAllPaperGeneratedItems(this.paperGeneratedId)).map(
      paperGeneratedItem => {
        const { parentOrder, isSubOrder } = getOrderPaperGeneratedItem(
          paperGeneratedItem.order,
        );

        if (
          parentOrder &&
          currentParentOrder &&
          parentOrder === currentParentOrder
        ) {
          // NOTE: add all suborder to groupQuestion
          const subPaperGeneratedItem: PaperGeneratedItem = {
            ...paperGeneratedItem,
            newQuestionGenerateds: [],
            selectedNewQuestionGenerated: null,
            hasChange: false,
            subOrder: null,
          };

          if (paperGeneratedItem.type === PaperGeneratedItemType.Question) {
            subPaperGeneratedItem.subOrder = currentSubOrder;
            currentSubOrder += 1;
          }

          this.paperGeneratedItemsGroups[
            parentOrder - 1
          ].paperGeneratedItems.push(subPaperGeneratedItem);
        } else {
          // NOTE: for normal paperGeneratedItem but groupQuestion is not empty coz of prev

          const currentPaperGeneratedItem: PaperGeneratedItem = {
            ...paperGeneratedItem,
            newQuestionGenerateds: [],
            selectedNewQuestionGenerated: null,
            hasChange: false,
            subOrder: null,
          };

          const paperGeneratedItemsGroup: PaperGeneratedItemsGroup = {
            order: null,
            paperGeneratedItems: [currentPaperGeneratedItem],
          };

          if (isSubOrder) {
            currentSubOrder = 1;
            if (paperGeneratedItem.type === PaperGeneratedItemType.Question) {
              currentPaperGeneratedItem.subOrder = currentSubOrder;
              currentSubOrder += 1;
            }

            currentParentOrder = parentOrder;
            paperGeneratedItemsGroup.order = currentOrder;
            currentOrder += 1;
          } else {
            currentParentOrder = null;
          }

          if (
            !currentParentOrder &&
            paperGeneratedItem.type === PaperGeneratedItemType.Question
          ) {
            paperGeneratedItemsGroup.order = currentOrder;
            currentOrder += 1;
          }

          this.paperGeneratedItemsGroups.push(paperGeneratedItemsGroup);
        }
      },
    );

    this.isLoading = false;
  }

  generateNewClick(selectedpaperGeneratedItem: PaperGeneratedItem) {
    this.selectedpaperGeneratedItem = selectedpaperGeneratedItem;
    this.openModalGenerateQuestion && this.openModalGenerateQuestion();
  }

  openModalGenerateQuestionAdd(openModal: any) {
    this.openModalGenerateQuestion = openModal;
  }

  getAllPaperGeneratedItems() {
    const paperGeneratedItems: PaperGeneratedItem[] = [];

    for (const paperGeneratedItemsGroup of this.paperGeneratedItemsGroups) {
      for (const paperGeneratedItem of paperGeneratedItemsGroup.paperGeneratedItems) {
        paperGeneratedItems.push(paperGeneratedItem);
      }
    }

    return paperGeneratedItems;
  }

  updateNewQuestionGenerated(params: {
    paperGeneratedItemId: number;
    newQuestionGenerated: GenerateQuestion;
  }) {
    params;
    const selectedPaperGeneratedItem = this.getAllPaperGeneratedItems().find(
      paperGeneratedItem =>
        paperGeneratedItem.id === params.paperGeneratedItemId,
    );

    if (selectedPaperGeneratedItem) {
      selectedPaperGeneratedItem.newQuestionGenerateds.push(
        params.newQuestionGenerated,
      );

      selectedPaperGeneratedItem.selectedNewQuestionGenerated =
        selectedPaperGeneratedItem.newQuestionGenerateds.length - 1;
    }
  }

  async getNewPaperName() {
    const paperName = prompt('New Paper Name:');
    if (paperName == null || paperName == '') {
      this.$toasted.global.mainToast({
        message: 'Need New Paper Name',
      });
    } else {
      await this.createNewGeneratedPaper(paperName);
    }
  }

  async createNewGeneratedPaper(paperName: string) {
    let subjectUuid: string | null = null;
    let chapterId: number | null = null;
    let form: number | null = null;

    if (this.paperGenerated) {
      if (this.paperGenerated.subject) {
        subjectUuid = this.paperGenerated.subject.uuid;
      }
      if (this.paperGenerated.chapter) {
        chapterId = this.paperGenerated.chapter.id;
      }
      if (this.paperGenerated.form) {
        form = this.paperGenerated.form;
      }
    }
    //create new paper
    const newPaper = await createPaperGenerated({
      name: paperName,
      subjectUuid,
      form,
      chapterId,
    });

    if (newPaper) {
      for (const paperGeneratedItem of this.getAllPaperGeneratedItems()) {
        let questionGeneratedId: number | null = null;

        if (paperGeneratedItem.questionGenerated) {
          questionGeneratedId = paperGeneratedItem.questionGenerated.id;
        }

        if (
          (paperGeneratedItem.selectedNewQuestionGenerated ||
            paperGeneratedItem.selectedNewQuestionGenerated === 0) &&
          paperGeneratedItem.newQuestionGenerateds.length
        ) {
          // create question if new
          const newQuestion = await createQuestionGenerated(
            paperGeneratedItem.newQuestionGenerateds[
              paperGeneratedItem.selectedNewQuestionGenerated
            ],
          );

          if (newQuestion) {
            questionGeneratedId = newQuestion.id;
          }
        }
        // create new paper item
        await createPaperGeneratedItem({
          order: paperGeneratedItem.order,
          type: paperGeneratedItem.type,
          paperGeneratedId: newPaper.id,
          questionGeneratedId,
          text: paperGeneratedItem.text,
        });
      }

      this.$router.push({
        path: `/generated-papers/${newPaper.id}`,
      });
      this.$router.go(0);
    }
  }

  async updateGeneratedPaper() {
    if (this.paperGenerated && this.paperGenerated.isOriginal) return;

    for (const paperGeneratedItem of this.getAllPaperGeneratedItems()) {
      if (
        paperGeneratedItem.questionGenerated &&
        (paperGeneratedItem.selectedNewQuestionGenerated ||
          paperGeneratedItem.selectedNewQuestionGenerated === 0) &&
        paperGeneratedItem.newQuestionGenerateds.length
      ) {
        // NOTE: Update because generate new question
        const questionGeneratedId = paperGeneratedItem.questionGenerated.id;

        // Update question
        if (paperGeneratedItem.questionGenerated.parentId) {
          await updateQuestionGenerated(
            questionGeneratedId,
            paperGeneratedItem.newQuestionGenerateds[
              paperGeneratedItem.selectedNewQuestionGenerated
            ].html,
          );
        } else {
          const newQuestion = await createQuestionGenerated(
            paperGeneratedItem.newQuestionGenerateds[
              paperGeneratedItem.selectedNewQuestionGenerated
            ],
          );

          await updatePaperGeneratedItem(paperGeneratedItem.id, newQuestion.id);
        }
      } else if (
        paperGeneratedItem.questionGenerated &&
        paperGeneratedItem.hasChange
      ) {
        // NOTE: Update because manually edit question
        const questionGeneratedId = paperGeneratedItem.questionGenerated.id;
        await updateQuestionGenerated(
          questionGeneratedId,
          paperGeneratedItem.questionGenerated.html,
        );
      }
    }

    this.$router.go(0);
  }

  getAlphabet(order: number) {
    return getAlphabet(order - 1);
  }
}
